import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Container } from "components";
import Pagination from "components/pagination";
import { useToaster } from "hooks";
import moment from "moment";
import api from "services/api";

export const CitiesList = () => {
  const [cities, setCities] = useState({ cities: [], pagination: {} });
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const { setErrorToaster, setSuccessToaster } = useToaster();

  const fetchCities = async (page = 1) => {
    try {
      const response = await api.get(`/cities?page=${page}`);
      setCities(response?.data?.data || { cities: [], pagination: {} });
      setCurrentPage(page);
      console.log("fetchCities list:", response?.data?.data);
    } catch (error) {
      console.log("fetchCities errors:", error);
      setErrorToaster("Failed to fetch cities");
    }
  };

  useEffect(() => {
    fetchCities(1);
  }, []);

  const openDeleteModal = (id) => {
    setSelectedCityId(id);
    setDeleteModal(true);
  };

  const handleDeleteModelConfirmation = async () => {
    if (selectedCityId) {
      try {
        const response = await api.delete(`/cities/${selectedCityId}`);
        console.log("handleDeleteModelConfirmation:", response);
        setDeleteModal(false);
        setSelectedCityId(null);
        fetchCities(currentPage);
        setSuccessToaster("Successfully deleted city");
      } catch (error) {
        console.log("handleDeleteModelConfirmation Error:", error);
        setErrorToaster(error?.response?.data?.message || "Failed to delete city");
      }
    }
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      Active: "bg-success",
      Inactive: "bg-secondary",
    };
    return statusClasses[status] || "bg-secondary";
  };

  return (
    <Container>
      <div className="content-wrapper">
        <div
          className="container-xxl flex-grow-1 container-p-y"
          style={{ height: "43px" }}
        >
          <h4 className="card-header">Cities</h4>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary me-5 mb-4"
              onClick={() => navigate("/addCity")}
            >
              Add City
            </button>
          </div>
          <div className="card-datatable table-responsive">
            <table className="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
              <thead>
                <tr>
                  <th>Sno</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created On</th>
                  <th>Updated On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cities?.cities?.map((city, index) => {
                  const serialNumber =
                    (currentPage - 1) * (cities?.pagination?.per_page || 10) +
                    (index + 1);
                  return (
                    <tr key={city.city_id}>
                      <td>{serialNumber}</td>
                      <td>{city?.name}</td>
                      <td>
                        <span className={`badge ${getStatusBadge(city?.status)}`}>
                          {city?.status}
                        </span>
                      </td>
                      <td>
                        {city?.created_on
                          ? moment(city.created_on).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {city?.updated_on
                          ? moment(city.updated_on).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        <FontAwesomeIcon
                          title="Edit"
                          icon={faPencil}
                          className="me-3"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(`/editCity/${city.city_id}`)
                          }
                        />
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ cursor: "pointer", color: "#dc3545" }}
                          onClick={() => openDeleteModal(city.city_id)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {cities?.pagination?.total > 0 && (
              <Pagination
                totalPages={cities?.pagination?.total}
                perPage={cities?.pagination?.per_page}
                handleFunction={fetchCities}
              />
            )}
          </div>
        </div>
      </div>
      {deleteModal && (
        <div className="modal show d-block" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Are you sure you want to delete this city?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => setDeleteModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleDeleteModelConfirmation}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

